if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}

(() => {
  if (window.__bnbMobileVariantDropdowns) return;
  window.__bnbMobileVariantDropdowns = true;

  const selectSelector =
    'variant-selects .product-form__input--dropdown .select > select.form-control--select';

  const optionText = (option) => option?.textContent?.replace(/\s+/g, ' ').trim() || '';

  const setOpen = (dropdown, open) => {
    const trigger = dropdown.querySelector('.bnb-mobile-variant-dropdown__trigger');
    const menu = dropdown.querySelector('.bnb-mobile-variant-dropdown__menu');
    dropdown.classList.toggle('is-open', open);
    trigger?.setAttribute('aria-expanded', String(open));
    if (menu) menu.hidden = !open;
  };

  const closeOtherDropdowns = (current) => {
    document.querySelectorAll('.bnb-mobile-variant-dropdown.is-open').forEach((dropdown) => {
      if (dropdown !== current) setOpen(dropdown, false);
    });
  };

  const initSelect = (select) => {
    if (!select || select.dataset.bnbMobileDropdownReady === 'true') return;

    const shell = select.closest('.select');
    const field = select.closest('.product-form__input--dropdown');
    if (!shell || !field || select.options.length < 2) return;

    select.dataset.bnbMobileDropdownReady = 'true';
    shell.classList.add('bnb-mobile-variant-ready');

    const dropdown = document.createElement('div');
    dropdown.className = 'bnb-mobile-variant-dropdown';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'bnb-mobile-variant-dropdown__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    const selectedText = document.createElement('span');
    selectedText.className = 'bnb-mobile-variant-dropdown__value';

    const caret = document.createElement('span');
    caret.className = 'bnb-mobile-variant-dropdown__caret';
    caret.setAttribute('aria-hidden', 'true');

    trigger.append(selectedText, caret);

    const menu = document.createElement('div');
    const menuId = `${select.id || 'bnb-variant'}-mobile-menu`;
    menu.id = menuId;
    menu.className = 'bnb-mobile-variant-dropdown__menu';
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;
    trigger.setAttribute('aria-controls', menuId);

    dropdown.append(trigger, menu);
    shell.appendChild(dropdown);

    const render = () => {
      const selectedOption = select.selectedOptions[0] || select.options[0];
      const currentText = optionText(selectedOption);
      const optionName = select.name.replace(/^options\[/, '').replace(/\]$/, '') || 'option';

      selectedText.textContent = currentText;
      trigger.setAttribute('aria-label', `Choose ${optionName}. Current selection ${currentText}`);

      const selectedLabel = field.querySelector('[data-selected-swatch-value]');
      if (selectedLabel && selectedOption) selectedLabel.textContent = selectedOption.value;

      menu.replaceChildren();

      Array.from(select.options).forEach((option, index) => {
        const item = document.createElement('button');
        const label = optionText(option);
        item.type = 'button';
        item.className = 'bnb-mobile-variant-dropdown__option';
        item.dataset.value = option.value;
        item.dataset.index = String(index);
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', String(option === selectedOption));
        item.textContent = label;

        if (option === selectedOption) item.classList.add('is-selected');
        if (/unavailable/i.test(label)) item.classList.add('is-unavailable');
        if (option.disabled) {
          item.disabled = true;
          item.setAttribute('aria-disabled', 'true');
        }

        item.addEventListener('click', () => {
          if (item.disabled) return;
          select.value = option.value;
          selectedText.textContent = label;
          setOpen(dropdown, false);
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });

        item.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
          event.preventDefault();
          const enabledItems = Array.from(
            menu.querySelectorAll('.bnb-mobile-variant-dropdown__option:not(:disabled)')
          );
          const currentIndex = enabledItems.indexOf(item);
          const direction = event.key === 'ArrowDown' ? 1 : -1;
          const nextIndex = (currentIndex + direction + enabledItems.length) % enabledItems.length;
          enabledItems[nextIndex]?.focus();
        });

        menu.appendChild(item);
      });
    };

    trigger.addEventListener('click', () => {
      const willOpen = !dropdown.classList.contains('is-open');
      closeOtherDropdowns(dropdown);
      setOpen(dropdown, willOpen);
      if (willOpen) {
        window.requestAnimationFrame(() => {
          menu.querySelector('[aria-selected="true"]')?.focus();
        });
      }
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      event.preventDefault();
      closeOtherDropdowns(dropdown);
      setOpen(dropdown, true);
      const items = Array.from(
        menu.querySelectorAll('.bnb-mobile-variant-dropdown__option:not(:disabled)')
      );
      const target = event.key === 'ArrowUp' ? items.at(-1) : items[0];
      target?.focus();
    });

    select.addEventListener('change', () => {
      render();
      setOpen(dropdown, false);
    });

    render();
  };

  const initAll = (root = document) => {
    if (root.matches?.(selectSelector)) initSelect(root);
    root.querySelectorAll?.(selectSelector).forEach(initSelect);
  };

  let initFrame = 0;
  const scheduleInit = () => {
    window.cancelAnimationFrame(initFrame);
    initFrame = window.requestAnimationFrame(() => initAll());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('variant:changed', scheduleInit);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

  new MutationObserver(scheduleInit).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.bnb-mobile-variant-dropdown.is-open').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) setOpen(dropdown, false);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openDropdown = document.querySelector('.bnb-mobile-variant-dropdown.is-open');
    if (!openDropdown) return;
    setOpen(openDropdown, false);
    openDropdown.querySelector('.bnb-mobile-variant-dropdown__trigger')?.focus();
  });
})();
